import type { NavigationRouter } from "@app/navigation/types";
import type { QueryClient } from "@tanstack/react-query";

import type { ReactNode } from "react";

import { useFeatureToggle } from "@kode-frontend/feature-toggle-react";
import { RouterProvider } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";

import { $session } from "@entities/session";
import { getClientEnv } from "@shared/libs/runtime-env";

export type Props = {
  children?: ReactNode;
  queryClient: QueryClient;
  router: NavigationRouter;
};

export const NavigationProvider = ({
  children,
  queryClient,
  router,
}: Props) => {
  const isDev = getClientEnv("DEV", false);
  const FT = useFeatureToggle();
  return (
    <>
      {children}
      <RouterProvider
        context={{
          getAuthStatus: () => $session.getState().accessToken !== undefined,
          hasFeatureFlag: FT.hasFeatureFlag,
          queryClient,
        }}
        router={router}
      />
      {isDev && (
        <TanStackRouterDevtools
          position="bottom-right"
          router={router}
          toggleButtonProps={{
            style: { bottom: "60px" },
          }}
        />
      )}
    </>
  );
};
